import React, { useCallback, useEffect, useState } from "react";

import LabelledComponent from "components/BudgetBuilder/Setup/LabelledComponent";
import Dropdown from "components/Dropdown";
import { api } from "services";
import { notifyError } from "utils";

const RateTypeDropdown = ({ editable, unitId, rateType, onChange, ...props }) => {
	const [ rateTypes, setRateTypes ] = useState([]);

	const loadRateTypes = useCallback(async unitId => {
		try {
			const response = await api.picklists.getRateTypes({ unitId });

			const rateTypeList = Array.isArray(response) ? response : [];

			const rateTypesIsNotExists = !rateTypeList.find(savedRateType => savedRateType.id === rateType?.id);

			if (rateType?.id && rateTypesIsNotExists) {
				onChange(null);
			}
			setRateTypes(rateTypeList);

		} catch (error) {
			notifyError("Something went wrong. Please try again.", error);
		}
	}, [ onChange ]);

	useEffect(() => {
		if (unitId) {
			loadRateTypes(unitId);
		}
	}, [ unitId ]);

	const handleChange = (event, { value: rateType }) => {
		const selectedRateType = rateTypes.find(savedRateType => savedRateType.id === rateType);
		onChange(selectedRateType);
	};

	const rateTypeOptions = rateTypes.map(rateType => ({ text: rateType.name, value: rateType.id }));

	return (
		<LabelledComponent label={"F&A Rate Type"}>
			{editable
				? <Dropdown
					{...props}
					selection
					placeholder={"Rate Types"}
					options={rateTypeOptions}
					onChange={handleChange}
					value={rateType?.id || ""}
				  />
				: rateType?.name
			}
		</LabelledComponent>
	);
};

export default RateTypeDropdown;
